import { render, staticRenderFns } from "./history.vue?vue&type=template&id=7b13b562&"
import script from "./history.js?vue&type=script&lang=js&"
export * from "./history.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports